import keyMirror from 'keymirror';

export const labelLayout = keyMirror({
  topLeft: null,
  bottomLeft: null,
});

export default [
  {
    value: labelLayout.topLeft,
    label: 'Top left',
  },
  {
    value: labelLayout.bottomLeft,
    label: 'Bottom left',
  },
];
